/** Search-index entries for rashi deep-dive topics (3.2–3.13). */
import { RASHI_DEEP_DIVE_TOPICS } from './jyotishaRashiDeepDive';

export const RASHI_DEEP_DIVE_SEARCH_INDEX = RASHI_DEEP_DIVE_TOPICS.map((t) => ({
  id: t.id,
  groupLabel: 'राशि (Rashis)',
  tabLabel: `${t.tabEn}`,
  terms: [
    t.id,
    t.slug,
    t.hi,
    t.en,
    t.latin,
    'rashi rashi sign zodiac deep dive mesha aries vrishabha taurus mithuna gemini karka cancer simha leo kanya virgo tula libra vrishchika scorpio dhanu sagittarius makara capricorn kumbha aquarius meena pisces lord element symbolism kalapurush nakshatra exalted debilitated',
  ].join(' '),
}));

export const RASHI_DEEP_DIVE_READ_MINUTES = Object.fromEntries(
  RASHI_DEEP_DIVE_TOPICS.map((t) => [t.id, 12]),
);

export const RASHI_DEEP_DIVE_ICONS = Object.fromEntries(
  [
    ['rashi-mesha', '🐏'],
    ['rashi-vrushabh', '🐂'],
    ['rashi-mithun', '👯'],
    ['rashi-kark', '🦀'],
    ['rashi-singh', '🦁'],
    ['rashi-kanya', '🌾'],
    ['rashi-tula', '⚖️'],
    ['rashi-vrischika', '🦂'],
    ['rashi-dhanu', '🏹'],
    ['rashi-makar', '🐐'],
    ['rashi-kumbh', '🏺'],
    ['rashi-meena', '🐟'],
  ],
);
